import React, { useState, useEffect } from "react";
import { Modal } from "@material-ui/core";
import styled from "styled-components/macro";
import { CampaignType, CampaignCategory } from "pages/dealScreener/Email/constants";

import { NewBlastModalBody } from "./";

const StyledModal = styled(Modal)`&& {
  box-shadow: 0px 4px 8px 0px #00000040;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}`;

const NewBlastModal = ({
  open,
  onClose: handleOnClose,
  setNewCampaignFlag,
  onCreateClicked
}) => {
  const [selectedBlastLevel, setSelectedBlastLevel] = useState(CampaignCategory.DEAL.id);
  const [selectedBlastType, setSelectedBlastType] = useState(null);
  const [blastTypeOptions, setBlastTypeOptions] = useState([]);
  const [blastName, setBlastName] = useState("");
  const [isBlastTypeValid, setIsBlastTypeValid] = useState(false);
  const [isBlastNameValid, setIsBlastNameValid] = useState(false);

  useEffect(() => {
    const blastTypeOptionsFilteredByBlastLevel = Object.values(CampaignType).filter(ct => ct.categoryId === selectedBlastLevel);

    /*
     * Temporarily removing all deal based campaign blast types except prepayment and valuation sensitivity because that's all the static page we've got built. Per conversation with Heather.
     * #2xj7ex2 20220701 Tim Lee
     * setBlastTypeOptions(blastTypeOptionsFilteredByBlastLevel);
     */
    if (selectedBlastLevel === CampaignCategory.DEAL.id) {
      const onlyPrepaymentAndValuation = blastTypeOptionsFilteredByBlastLevel
        .filter(bto => bto.id === CampaignType.VALUATION_SENSITIVITY.id || bto.id === CampaignType.PREPAYMENT.id);
      setBlastTypeOptions(onlyPrepaymentAndValuation);
    }
    setSelectedBlastType(null);
  }, [selectedBlastLevel]);

  useEffect(() => {
    setIsBlastNameValid(Boolean(blastName));
    setIsBlastTypeValid(Boolean(selectedBlastType));
  }, [selectedBlastType, blastName]);

  const handleCreateCampaignClicked = () => {
    setNewCampaignFlag(true);
    onCreateClicked(blastName, selectedBlastType);
  };

  return (
    <StyledModal
      open={open}
      onClose={handleOnClose}
    >
      <NewBlastModalBody
        selectedBlastLevel={selectedBlastLevel}
        setSelectedBlastLevel={setSelectedBlastLevel}
        selectedBlastType={selectedBlastType}
        setSelectedBlastType={setSelectedBlastType}
        blastTypeOptions={blastTypeOptions}
        blastName={blastName}
        setBlastName={setBlastName}
        onCancelClicked={handleOnClose}
        onCreateClicked={handleCreateCampaignClicked}
        isBlastTypeValid={isBlastTypeValid}
        isBlastNameValid={isBlastNameValid}
      />
    </StyledModal>
  );
};

export default NewBlastModal;
